import { render, staticRenderFns } from "./CmgAemHome.vue?vue&type=template&id=3a5a30b0&scoped=true&lang=pug&"
import script from "./cmg-aem-home.ts?vue&type=script&lang=ts&"
export * from "./cmg-aem-home.ts?vue&type=script&lang=ts&"
import style0 from "./CmgAemHome.vue?vue&type=style&index=0&id=3a5a30b0&lang=scss&scoped=true&"
import style1 from "./CmgAemHome.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a5a30b0",
  null
  
)

export default component.exports